import styled, { css } from 'styled-components';

export const PaginatedGroupList = styled.div`
  display: flex;
  flex-direction: column;

  &:last-child {
    overflow: hidden;
    border-bottom-left-radius: ${({ theme }) => theme.spacing(1)};
    border-bottom-right-radius: ${({ theme }) => theme.spacing(1)};
  }
`;

const rowLayout = css`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  width: 100%;
  padding: ${({ theme }) => theme.spacing(1.75, 2.5)};
  border: none;
  background: transparent;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  text-align: left;

  &:last-child {
    border-bottom: none;
  }
`;

export const GroupRow = styled.button`
  ${rowLayout};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.palette.grey[50]};
  }
`;

export const StaticGroupRow = styled.div`
  ${rowLayout};
`;

export const TypeChipCell = styled.div`
  display: flex;
  flex-shrink: 0;
  width: ${({ theme }) => theme.spacing(10.5)};
`;

export const GroupRowText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const GroupRowName = styled.span`
  font-size: ${({ theme }) => theme.typography.subtitle2.fontSize};
  font-weight: ${({ theme }) => theme.typography.subtitle2.fontWeight};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Chevron = styled.span`
  display: inline-flex;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const SearchWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${({ theme }) => theme.spacing(1.5, 2.5)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  .MuiTextField-root {
    width: ${({ theme }) => theme.spacing(32.5)};
  }
`;

export const PaginationWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const EmptyNote = styled.p`
  margin: 0;
  padding: ${({ theme }) => theme.spacing(2.5)};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const SkeletonRows = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(1.75, 2.5)};
`;

export const GroupsHeader = styled.div`
  display: flex;
  align-items: center;
  min-height: 68px;
  padding: ${({ theme }) => theme.spacing(2, 2.5)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;
